import { render, staticRenderFns } from "./DocumentMain.vue?vue&type=template&id=47f521ee&scoped=true&"
import script from "./DocumentMain.vue?vue&type=script&lang=js&"
export * from "./DocumentMain.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMain.vue?vue&type=style&index=0&id=47f521ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f521ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
